var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "row orders_to_call_row" }, [
      _c("div", { staticClass: "col-md-12" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: { loading: _vm.loading, color: _vm.color },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-12 orders_to_call_div" }, [
        _vm.orders
          ? _c("div", { staticClass: "card" }, [
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("CabinOrdersRunnerTable", {
                    attrs: {
                      orders: _vm.orders,
                      runner: _vm.runner,
                      mainTaskId: _vm.mainTaskId,
                      runnerTasksIncome: _vm.tasks,
                    },
                  }),
                ],
                1
              ),
            ])
          : _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("h5", [_vm._v(_vm._s(_vm.errorMessage))]),
              ]),
            ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }